/**
 * V2批量打印任务接口封装，所有动作都使用POST和JSON请求体。
 */
import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 创建V2批量打印任务
export function createPrintTask(data) {
  return request({
    url: URL.report.printTaskV2Create,
    method: 'post',
    data,
    timeout: 30 * 1000
  })
}

// 查询V2批量打印任务进度
export function getPrintTask(printId) {
  return request({
    url: URL.report.printTaskV2Query,
    method: 'post',
    data: { printId },
    timeout: 15 * 1000
  })
}

// 查询批量打印前端模式；浏览器刷新时初始化一次
export function getPrintTaskClientMode() {
  return request({
    url: URL.report.printTaskV2ClientMode,
    method: 'get',
    timeout: 10 * 1000
  })
}

// 按任务ID下载打印结果，返回二进制文件流
export function downloadPrintTaskResult(printId) {
  return request({
    url: URL.report.printTaskV2Download,
    method: 'post',
    data: { printId },
    responseType: 'blob',
    passthroughBlob: true,
    timeout: 5 * 60 * 1000
  })
}
